import { AUTH_SERVICE } from '@common/services/auth/auth.service.interface';
import userStore, { useUserStore } from '@input-web/modules/user/stores/user.store';
import { useQuery } from '@tanstack/react-query';
import { User } from '@user/models/user.model';
import { useEffect } from 'react';
import { container } from 'tsyringe';

// #region Constants
export const USER_INFO_QUERY_KEY = 'auth-me';
// #endregion

/**
 * Hook for handling user authentication verification
 * Manages auth me mutation and user store updates
 */
export default function useUserInfoQuery() {
  // #region Dependencies
  const { token } = useUserStore();
  // #endregion

  // #region Queries
  const { data, isLoading } = useQuery<User | null>({
    enabled: !!token,
    queryFn: container.resolve(AUTH_SERVICE).getUserInfo,
    queryKey: [USER_INFO_QUERY_KEY],
  });
  // #endregion

  // #region Effects
  useEffect(() => userStore.actions.setUser(data ?? undefined), [data]);
  // #endregion

  return { data, isLoading };
}
